<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import SwapIcon from './SwapIcon.vue';
</script>

<template>
  <call-action :title="trans('voip.calls.call_action.swap_trans')">
    <swap-icon />
  </call-action>
</template>
